import ApiService from "./api.service";

const ScienceSourceService = {
  getAll: async function (params = {}, lang = null) {
    const response = await ApiService._get("api/science-source/platform-science-source", params, lang);
    return response.data;
  },

  getById: async function (id, lang = null) {
    const response = await ApiService.get(`api/science-source/platform-science-source/${id}`, lang);
    return response.data;
  },

  create: async function (params = {}, lang = null) {
    const response = await ApiService.post("api/science-source/platform-science-source", params, lang);
    return response.data;
  },

  update: async function (id, params = {}, lang = null) {
    const response = await ApiService.put(`api/science-source/platform-science-source/${id}`, params, lang);
    return response.data;
  },

  remove: async function (id, lang = null) {
    const response = await ApiService.delete(`api/science-source/platform-science-source/${id}`, lang);
    return response.data;
  },
};

export default ScienceSourceService;
